import React from 'react';
import i18n from 'i18n';
import { Trans } from 'react-i18next';
import { getCurrencyLabel } from 'helper/CurrencyHelper';

export const renderOverBudgetWording = (
  currency: string,
  overBudget: number
) => {
  const wording = i18n.t('campaign.descriptions.overed');
  return (
    <Trans
      i18nKey='campaign.descriptions.overBudget'
      values={{ wording, currency: getCurrencyLabel(currency), overBudget }}
      components={{
        1: <span className='tip_normal' />,
        2: <span className='text-dark' />
      }}
    />
  );
};
